import React, { useState, useEffect, useReducer } from 'react';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../../_metronic/_partials/controls';
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from '../../../../../../../_metronic/_helpers';
import Numeric from '../../../../../../components/Numeric';
import axios, { baseUrl } from '../../../../../../../redux/my-axios';
import SelectedProduct from '../../../../../../components/SelectProduct';
import * as columnFormatters from '../../../../../../components/SelectProduct/List/column-formatters';
import css from './style.module.css';
import DialogBox from '../../../../../../components/DialogBox';

export const ITEMS_URL = '/items';
function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return { items: action.payload };
    case 'insert':
      return { items: [...state.items, ...action.payload] };
    case 'remove':
      return {
        items: state.items.filter((item) => {
          if (item.productCode !== action.payload) return item;
        }),
      };
    case 'updateprice':
      return {
        items: state.items.map((item) => {
          if (item.productCode === action.payload.id) {
            let temp = parseFloat(
              action.payload.newPrice
                .toString()
                .replace('$', '')
                .replace(',', '')
            );
            const updatedItem = {
              ...item,
              unitPrice: temp,
              totalPrice:
                Math.round((temp * item.qty + Number.EPSILON) * 100) / 100,
            };

            return updatedItem;
          }

          return item;
        }),
      };
    case 'updatecount':
      return {
        items: state.items.map((item) => {
          if (item.productCode === action.payload.id) {
            let temp = Number(action.payload.newCount);
            let temp2 = parseFloat(
              item.unitPrice
                .toString()
                .replace('$', '')
                .replace(',', '')
            );
            const updatedItem = {
              ...item,
              qty: temp,
              totalPrice:
                Math.round((temp * temp2 + Number.EPSILON) * 100) / 100,
            };

            return updatedItem;
          }

          return item;
        }),
      };
    default:
      throw new Error();
  }
}

export default function SaleItems(props) {
  const { sale, updateSubTotalAmount } = props;
  const [err, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [openSelectProducts, setOpenSelectProducts] = useState(false);
  const [openConfirmRemoveItem, setOpenConfirmRemoveItem] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, dispatch] = useReducer(reducer, { items: [] });
  const [toRemoveItem, setToRemoveItem] = useState();
  const [sortId, setSortId] = useState(1);

  function NameColumnFormatter(cellContent, row) {
    return (
      <div
        style={{
          display: 'flex-inline',
          justifyContent: 'left',
          alignItems: 'left',
        }}
      >
        <div style={{ display: 'flex' }}>
          <span style={{ fontStyle: 'bold', fontSize: 'large' }}>
            {cellContent}
          </span>
          <span
            style={{
              fontStyle: 'italic',
              fontSize: 'small',
              textAlign: 'right',
              alignContent: 'end',
            }}
          >
            [{row.count}]
          </span>
        </div>
        <div
          style={{
            fontStyle: 'italic',
            fontSize: 'small',
          }}
        >
          {row.productCode}
        </div>
      </div>
    );
  }
  function ProductPriceColumnFormatter(cellContent, row) {
    return (
      <>
        <Numeric
          key={`productPricePer_${row.productCode}`}
          name='productPricePer'
          value={cellContent}
          decimalScale='0'
          fixedDecimalScale={false}
          onBlur={(e) => {
            setPriceVal(row.productCode, e);
          }}
          /*         onChange={(e) => {
          onChangePriceVal(row.productCode, e);
        }} */
          className='form-control form-control-sm'
          negative={false}
          prefix=''
        />
        {cellContent !== row.price ? <small>{row.price}</small> : <></>}
      </>
    );
  }
  function ProductQuantityColumnFormatter(cellContent, row) {
    return (
      <>
        <Numeric
          key={`productQuantity_${row.productCode}`}
          name='productQuantity'
          value={cellContent}
          onBlur={(e) => {
            setQuantityVal(row.productCode, e);
          }}
          className='form-control form-control-sm'
          negative={false}
          type='number'
          decimalScale='0'
          fixedDecimalScale={false}
        />
      </>
    );
  }
  function ActionsColumnFormatter(cellContent, row, rowIndex) {
    return (
      <>
        <a
          title='Бүтээгдэхүүний сонголт устгах'
          className='btn btn-icon btn-light btn-hover-danger btn-sm'
          onClick={() => removeItem(row)}
        >
          <span className='svg-icon svg-icon-md svg-icon-danger'>
            <SVG src={toAbsoluteUrl('/media/svg/icons/General/Trash.svg')} />
          </span>
        </a>
      </>
    );
  }
  function DecimalColumnFormatter(cellContent, row) {
    return (
      <div>
        {cellContent
          ? cellContent
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
          : '0.00'}
      </div>
    );
  }

  const columns = [
    {
      dataField: 'icon',
      text: '',
      sort: false,
      style: {
        width: '65px',
      },
      formatter: columnFormatters.IconColumnFormatter,
    },
    {
      dataField: 'name',
      text: 'Бүтээгдэхүүн',
      sort: false,
      formatter: NameColumnFormatter,
    },
    {
      dataField: 'unitPrice',
      text: 'Үнэ',
      sort: false,
      formatter: ProductPriceColumnFormatter,
      classes: 'text-right pr-1',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '90px',
        width: '90px',
      },
    },
    {
      dataField: 'qty',
      text: 'Тоо',
      sort: false,
      formatter: ProductQuantityColumnFormatter,
      classes: 'text-right pr-1',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '60px',
        width: '70px',
      },
    },
    {
      dataField: 'totalPrice',
      text: 'Дүн',
      sort: false,
      classes: 'text-right pr-2',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '60px',
      },
      formatter: DecimalColumnFormatter,
    },
    {
      dataField: 'action',
      text: '',
      formatter: ActionsColumnFormatter,

      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '50px',
      },
    },
  ];

  useEffect(() => {
    let arr = [];
    for (let i = 0; i < sale.items.length; i++) {
      arr.push({
        productCode: sale.items[i].productCode,
        icon: sale.items[i].icon,
        name: sale.items[i].name,
        unitPrice: sale.items[i].unitPrice,
        qty: sale.items[i].qty,
        totalPrice: sale.items[i].totalPrice,
        price: sale.items[i].price,
        count: sale.items[i].count,
        brandName: sale.items[i].brandName,
        sortNo: sale.items[i].sortNo,
        color: sale.items[i].color,
        sizeValue: sale.items[i].sizeValue,
        cost: sale.items[i].cost,
      });
    }
    if (sale) dispatch({ type: 'init', payload: arr });
    setTotalCount(state.items.length);
    //console.log('RefreshedItems', state.items);
  }, [sale]);

  useEffect(() => {
    updateSubTotalAmount(state.items);
  }, [state]);

  const onItemsAddClick = () => {
    setOpenSelectProducts(true);
  };

  const addSelectedItems = (selectedItems) => {
    //console.log('SelectedRows to add: ', selectedItems);
    let sortNo = sortId;
    let temp = [];
    if (selectedItems !== undefined) {
      for (let i = 0; i < selectedItems.length; i++) {
        let t = selectedItems[i];
        temp.push({
          productCode: t.productCode,
          name: t.name,
          icon: t.icon,
          unitPrice: t.price,
          price: t.price,
          qty: 1,
          totalPrice: t.price * 1,
          count: t.count,
          brandName: t.brandName,
          sortNo: sortNo,
          sizeValue: t.sizeValue,
          color: t.color,
          cost: t.cost,
        });
        sortNo++;
      }
      setSortId(sortNo);
      dispatch({ type: 'insert', payload: temp });
    }
  };

  const removeItem = (item) => {
    // confirm
    setToRemoveItem(item);
    setOpenConfirmRemoveItem(true);
  };
  const remove = () => {
    //console.log('remove', productCode);

    dispatch({ type: 'remove', payload: toRemoveItem.productCode });
  };

  function handleToggleCompletePrice(id, newPrice) {
    dispatch({ type: 'updateprice', payload: { id, newPrice } });
  }
  function handleToggleCompleteQuantity(id, newCount) {
    dispatch({ type: 'updatecount', payload: { id, newCount } });
  }
  const setQuantityVal = (id, quantity) => {
    handleToggleCompleteQuantity(id, quantity);
  };
  const setPriceVal = (id, productPricePer) => {
    handleToggleCompletePrice(id, productPricePer);
  };
  const onChangePriceVal = (id, productPricePer) => {
    handleToggleCompletePrice(id, productPricePer);
  };

  return (
    <div>
      {err ? (
        <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
          <div className='alert-text font-weight-bold'>{err}</div>
        </div>
      ) : (
        <div></div>
      )}
      {msg ? (
        <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
          <div className='alert-text font-weight-bold'>{msg}</div>
        </div>
      ) : (
        <div></div>
      )}
      {openSelectProducts && (
        <SelectedProduct
          openSelectProducts={openSelectProducts}
          setOpenSelectProducts={setOpenSelectProducts}
          addSelectedItems={addSelectedItems}
          //existingItems={entities}
          existingItems={state.items}
        />
      )}
      {toRemoveItem && (
        <DialogBox
          openDialog={openConfirmRemoveItem}
          setOpenDialog={setOpenConfirmRemoveItem}
          icon='question'
          iconColor='danger'
          title='Худалдан авалтын сонголтоос бараа хасах'
          text={`${toRemoveItem.name} #${toRemoveItem.productCode}  гэсэн сонгосон барааг устгахдаа итгэлтэй байна уу?'`}
          buttonOk={false}
          buttonYes={true}
          buttonNo={true}
          onConfirm={remove}
        ></DialogBox>
      )}
      <Card id='saleItemsCard'>
        {loading && <ModalProgressBar />}
        <CardHeader title={`Бараа - ${totalCount}`}>
          <CardHeaderToolbar>
            <>
              <button
                type='button'
                className='btn btn-secondary ml-2'
                onClick={onItemsAddClick}
              >
                <FormattedMessage id='GENERAL.BUTTON.ADD' />
                {loading && (
                  <span
                    id='saleItemsAdd'
                    className='ml-3 spinner spinner-white '
                  ></span>
                )}
              </button>
            </>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            wrapperClasses='table-responsive'
            classes='table table-head-custom table-vertical-center overflow-hidden'
            bootstrap4
            bordered={true}
            local
            keyField='productCode'
            //data={entities === null ? [] : entities}
            data={state.items === null ? [] : state.items}
            columns={columns}
            //onTableChange={getHandlerTableChange(setQueryParams)}
            /*  selectRow={getSelectRow({
              entities,
              ids,
              setIds,
            })} */
          >
            {/*  <PleaseWaitMessage entities={entities} />
            <NoRecordsFoundMessage entities={entities} /> */}
            <PleaseWaitMessage entities={state.items} />
            <NoRecordsFoundMessage entities={state.items} />
          </BootstrapTable>
        </CardBody>
      </Card>
    </div>
  );
}
